/* EGURRE — DROP · interacciones (se ejecuta una sola vez) */
(function () {
  if (window.__drInit) return;
  window.__drInit = true;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function countUp(el) {
    var to = parseInt(el.getAttribute('data-dr-count'), 10);
    if (isNaN(to)) return;
    if (reduce || to < 2) { el.textContent = to; return; }
    var start = null, dur = 1100;
    function step(ts) {
      if (!start) start = ts;
      var p = Math.min((ts - start) / dur, 1);
      el.textContent = Math.round(to * (1 - Math.pow(1 - p, 3)));
      if (p < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  function reveal(el) {
    el.classList.add('is-in');
    if (el.hasAttribute('data-dr-count') && !el.hasAttribute('data-dr-done')) { el.setAttribute('data-dr-done', '1'); countUp(el); }
  }

  function observe(root) {
    var els = (root || document).querySelectorAll('.dr-reveal:not(.is-in), [data-dr-count]:not([data-dr-done])');
    if (!('IntersectionObserver' in window) || reduce) { els.forEach(reveal); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { reveal(e.target); io.unobserve(e.target); } });
    }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el) { io.observe(el); });
    /* red de seguridad: lo que ya está en pantalla se muestra sí o sí */
    setTimeout(function () {
      els.forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.top < window.innerHeight && r.bottom > 0) reveal(el);
      });
    }, 1200);
  }

  function marquees(root) {
    (root || document).querySelectorAll('.dr-marquee:not([data-dr-ready])').forEach(function (m) {
      m.setAttribute('data-dr-ready', '1');
      var track = m.querySelector('.dr-marquee__track');
      if (!track) return;
      var guard = 0;
      while (track.scrollWidth < window.innerWidth * 1.2 && guard < 6) { track.innerHTML += track.innerHTML; guard++; }
      var clone = track.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      m.appendChild(clone);
    });
  }

  function parallax() {
    if (reduce) return;
    var items = document.querySelectorAll('[data-dr-parallax]');
    if (!items.length) return;
    var ticking = false;
    function run() {
      items.forEach(function (el) {
        var sp = parseFloat(el.getAttribute('data-dr-parallax')) || 0;
        if (!sp) return;
        var r = el.parentElement.getBoundingClientRect();
        if (r.bottom < 0 || r.top > window.innerHeight) return;
        var y = Math.max(0, -r.top) * sp;
        el.style.transform = 'translate3d(0,' + y.toFixed(1) + 'px,0)';
      });
      ticking = false;
    }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(run); } }, { passive: true });
    run();
  }

  function init() { marquees(); observe(); parallax(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', function (e) { marquees(e.target); observe(e.target); });
})();
